import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/Bullet/g5-pro.jpg";
import image from "../../assets/product-list-assets/cameras/bullet/g5-professional.jpg";
import type { Product } from "../../types";
import { bullet } from "../product-groups/cameraSecurity/Bullet";
import { bullet as bulletProductListGroup } from "../product-list-groups/bullet";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const g5Pro: Product = {
  id: "g5Pro",
  productTitle: "G5 Pro",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g5-pro`,
  ],
  storePathParts: {
    productSlug: "uvc-g5-pro",
    category: UniFiChildCategorySlug.CamerasBullet,
  },
  sku: "UVC-G5-Pro",
  description: "g5Pro.description",
  descriptionMaxWidth: 150,
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 250,
    height: 182,
  },
  productGroup: bullet,
  productListGroup: bulletProductListGroup,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø86 x 154.3 mm\n(Ø3.4 x 6.1")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/2" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g5Pro.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "g5Pro.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "string", value: "3x" },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.microphone" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP65" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
